module.exports = __webpack_public_path__ + "static/media/cosmetics.5c057def.webp";